import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScaffaliminicelleService {

  constructor() { }

   getData() {
        return [
                {
                  "MINI_CELLA": "12-12",
                  "CODICE_3_RIPIANI": "PM2228631",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 12-12",
                  "CODICE_4_RIPIANI": "PM2228731",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 12-12"
                },
                {
                  "MINI_CELLA": "12-14",
                  "CODICE_3_RIPIANI": "PM2228632",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 12-14",
                  "CODICE_4_RIPIANI": "PM2228732",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 12-14"
                },
                {
                  "MINI_CELLA": "12-16",
                  "CODICE_3_RIPIANI": "PM2228633",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 12-16",
                  "CODICE_4_RIPIANI": "PM2228733",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 12-16"
                },
                {
                  "MINI_CELLA": "12-18",
                  "CODICE_3_RIPIANI": "PM2228634",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 12-18",
                  "CODICE_4_RIPIANI": "PM2228734",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 12-18"
                },
                {
                  "MINI_CELLA": "12-20",
                  "CODICE_3_RIPIANI": "PM2228635",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 12-20",
                  "CODICE_4_RIPIANI": "PM2228735",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 12-20"
                },
                {
                  "MINI_CELLA": "12-22",
                  "CODICE_3_RIPIANI": "PM2228636",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 12-22",
                  "CODICE_4_RIPIANI": "PM2228736",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 12-22"
                },
                {
                  "MINI_CELLA": "12-24",
                  "CODICE_3_RIPIANI": "PM2228637",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 12-24",
                  "CODICE_4_RIPIANI": "PM2228737",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 12-24"
                },
                {
                  "MINI_CELLA": "12-28",
                  "CODICE_3_RIPIANI": "PM2228638",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 12-28",
                  "CODICE_4_RIPIANI": "PM2228738",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 12-28"
                },
                {
                  "MINI_CELLA": "14-14",
                  "CODICE_3_RIPIANI": "PM2228639",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 14-14",
                  "CODICE_4_RIPIANI": "PM2228739",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 14-14"
                },
                {
                  "MINI_CELLA": "14-16",
                  "CODICE_3_RIPIANI": "PM2228640",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 14-16",
                  "CODICE_4_RIPIANI": "PM2228740",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 14-16"
                },
                {
                  "MINI_CELLA": "14-18",
                  "CODICE_3_RIPIANI": "PM2228641",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 14-18",
                  "CODICE_4_RIPIANI": "PM2228741",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 14-18"
                },
                {
                  "MINI_CELLA": "14-20",
                  "CODICE_3_RIPIANI": "PM2228642",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 14-20",
                  "CODICE_4_RIPIANI": "PM2228742",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 14-20"
                },
                {
                  "MINI_CELLA": "14-22",
                  "CODICE_3_RIPIANI": "PM2228643",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 14-22",
                  "CODICE_4_RIPIANI": "PM2228743",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 14-22"
                },
                {
                  "MINI_CELLA": "14-24",
                  "CODICE_3_RIPIANI": "PM2228644",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 14-24",
                  "CODICE_4_RIPIANI": "PM2228744",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 14-24"
                },
                {
                  "MINI_CELLA": "14-28",
                  "CODICE_3_RIPIANI": "PM2228645",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 14-28",
                  "CODICE_4_RIPIANI": "PM2228745",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 14-28"
                },
                {
                  "MINI_CELLA": "16-16",
                  "CODICE_3_RIPIANI": "PM2228646",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 16-16",
                  "CODICE_4_RIPIANI": "PM2228746",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 16-16"
                },
                {
                  "MINI_CELLA": "16-18",
                  "CODICE_3_RIPIANI": "PM2228647",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 16-18",
                  "CODICE_4_RIPIANI": "PM2228747",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 16-18"
                },
                {
                  "MINI_CELLA": "16-20",
                  "CODICE_3_RIPIANI": "PM2228648",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 16-20",
                  "CODICE_4_RIPIANI": "PM2228748",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 16-20"
                },
                {
                  "MINI_CELLA": "16-22",
                  "CODICE_3_RIPIANI": "PM2228649",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 16-22",
                  "CODICE_4_RIPIANI": "PM2228749",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 16-22"
                },
                {
                  "MINI_CELLA": "16-24",
                  "CODICE_3_RIPIANI": "PM2228650",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 16-24",
                  "CODICE_4_RIPIANI": "PM2228750",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 16-24"
                },
                {
                  "MINI_CELLA": "16-28",
                  "CODICE_3_RIPIANI": "PM2228651",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 16-28",
                  "CODICE_4_RIPIANI": "PM2228751",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 16-28"
                },
                {
                  "MINI_CELLA": "18-18",
                  "CODICE_3_RIPIANI": "PM2228652",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 18-18",
                  "CODICE_4_RIPIANI": "PM2228752",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 18-18"
                },
                {
                  "MINI_CELLA": "18-20",
                  "CODICE_3_RIPIANI": "PM2228653",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 18-20",
                  "CODICE_4_RIPIANI": "PM2228753",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 18-20"
                },
                {
                  "MINI_CELLA": "18-22",
                  "CODICE_3_RIPIANI": "PM2228654",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 18-22",
                  "CODICE_4_RIPIANI": "PM2228754",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 18-22"
                },
                {
                  "MINI_CELLA": "18-24",
                  "CODICE_3_RIPIANI": "PM2228655",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 18-24",
                  "CODICE_4_RIPIANI": "PM2228755",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 18-24"
                },
                {
                  "MINI_CELLA": "18-28",
                  "CODICE_3_RIPIANI": "PM2228656",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 18-28",
                  "CODICE_4_RIPIANI": "PM2228756",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 18-28"
                },
                {
                  "MINI_CELLA": "20-20",
                  "CODICE_3_RIPIANI": "PM2228657",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 20-20",
                  "CODICE_4_RIPIANI": "PM2228757",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 20-20"
                },
                {
                  "MINI_CELLA": "20-22",
                  "CODICE_3_RIPIANI": "PM2228658",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 20-22",
                  "CODICE_4_RIPIANI": "PM2228758",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 20-22"
                },
                {
                  "MINI_CELLA": "20-24",
                  "CODICE_3_RIPIANI": "PM2228659",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 20-24",
                  "CODICE_4_RIPIANI": "PM2228759",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 20-24"
                },
                {
                  "MINI_CELLA": "20-28",
                  "CODICE_3_RIPIANI": "PM2228660",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 20-28",
                  "CODICE_4_RIPIANI": "PM2228760",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 20-28"
                },
                {
                  "MINI_CELLA": "22-22",
                  "CODICE_3_RIPIANI": "PM2228661",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 22-22",
                  "CODICE_4_RIPIANI": "PM2228761",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 22-22"
                },
                {
                  "MINI_CELLA": "22-24",
                  "CODICE_3_RIPIANI": "PM2228662",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 22-24",
                  "CODICE_4_RIPIANI": "PM2228762",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 22-24"
                },
                {
                  "MINI_CELLA": "22-28",
                  "CODICE_3_RIPIANI": "PM2228663",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 22-28",
                  "CODICE_4_RIPIANI": "PM2228763",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 22-28"
                },
                {
                  "MINI_CELLA": "24-24",
                  "CODICE_3_RIPIANI": "PM2228664",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 24-24",
                  "CODICE_4_RIPIANI": "PM2228764",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 24-24"
                },
                {
                  "MINI_CELLA": "24-28",
                  "CODICE_3_RIPIANI": "PM2228665",
                  "DESCRIZIONE_3_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 3S 24-28",
                  "CODICE_4_RIPIANI": "PM2228765",
                  "DESCRIZIONE_4_RIPIANI": "SET SCAFFALATURA PUREVER KLM/20 4S 24-28"
                }
              ];

   }
}
